import { MiUser, SendMiEmail, SignupMiUser } from '../models/miModel'
import { API } from './apiClient'

const BASE_URL = 'mi'

export const postSendEmail = (data: SendMiEmail): Promise<void> => {
  return API.post(`${BASE_URL}/send-email`, data, {})
}

export const postSignupData = (data: SignupMiUser): Promise<void> => {
  return API.post(`${BASE_URL}/signup`, data, {})
}

export const getMiData = (idToken: string): Promise<MiUser> => {
  return API.get(`${BASE_URL}`, { headers: { Authorization: idToken } })
}

export const putMiData = (data: MiUser, idToken: string): Promise<void> => {
  return API.put(`${BASE_URL}`, data, { headers: { Authorization: idToken } })
}

export const deleteMiData = (idToken: string): Promise<void> => {
  return API.delete(`${BASE_URL}`, { headers: { Authorization: idToken } })
}

// パスワード再設定用
export const postConfirmEmail = (data: SendMiEmail): Promise<void> => {
  return API.post(`${BASE_URL}/resend-email`, data, {})
}
